//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    export default {
      async fetch() {
        await Promise.all([ 
            this.$store.dispatch('pagesStore/getPage', 'gids'),
            this.$store.dispatch('epgStore/getEpg', this.queries.epg)
        ])
    },
    head() {
        return {
            title: this.pages.gids && this.pages.gids.seo ? this.pages.gids.seo.title : 'TV-gids | Meiden van Holland',
            meta: [
                { hid: 'title', name: 'title', content: this.pages.gids && this.pages.gids.seo ? this.pages.gids.seo.title : 'TV-gids | Meiden van Holland' },
                { hid: 'og:title', name: 'og:title', content: this.pages.gids && this.pages.gids.seo ? this.pages.gids.seo.title : 'TV-gids | Meiden van Holland' },
                { hid: 'description', name: 'description', content: this.pages.gids && this.pages.gids.seo ? this.pages.gids.seo.description : 'Nu te zien op televisie bij Meiden van Holland Hard'},
                { hid: 'og:description', name: 'og:description', content: this.pages.gids && this.pages.gids.seo ? this.pages.gids.seo.description : 'Nu te zien op televisie bij Meiden van Holland Hard' },
                { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/tv-gids' },
                { hid: 'keywords', name: 'keywords', content: this.pages.gids && this.pages.gids.seo ? this.pages.gids.seo.keywords : 'tvgids, epg, tv, televisie'},
            ]
        }
    },
    components: {
        epgNav: () => import('~/components/content/epg/epgNav'),
        epgItem: () => import('~/components/content/epg/epg.vue'),
        dummyItem: () => import('~/components/content/dummy/epg_dummy.vue')
    },
    computed: {
        ...mapState({
            queries: ({ epgStore: {queries} }) => queries,
            epg: ({ epgStore: {epg} }) => epg,
            loading: ({ epgStore: {loading} }) => loading,
            pages: ({ pagesStore: {pages} }) => pages,
        }),
    }
}
